import { render } from "./MaterialDelete.vue?vue&type=template&id=73eecbaa&lang=pug"
import script from "./MaterialDelete.vue?vue&type=script&lang=js"
export * from "./MaterialDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__